// @flow
import type { Action } from "redux-action";
import { sendSuccessMessage } from "@modules/app/actionCreator";
import actionCreators from "@modules/profile/actionCreator";
import http from "@http";
import {
  ChangePassword,
  GetContactInfoSchema,
  UpdateContactInfo,
} from "@modules/profile/constants/actions";
import { all, call, put, takeEvery } from "redux-saga/effects";
import { parseSchema } from "@utils/schema";
import type { MyDetails } from "@modules/profile/reducer/my-details/types";

export function* onGetContactInfoSchema(): Generator<*, void, Object> {
  try {
    const schema = yield parseSchema("PersonalContactInfoDTO");
    yield put(actionCreators.GetContactInfoSchemaSuccess(schema));
  } catch (e) {
    yield put(actionCreators.GetContactInfoSchemaError(e.response));
  }
}

export function* onChangePassword({
  payload,
}: Action<{
  userId: string | null,
  oldPassword: string | null,
  newPassword: string,
  newPasswordConfirm: string,
}>): Generator<*, void, Object> {
  try {
    // If this url is changed in the future you need to change it in translations file as well
    let url = `account/my-password`;
    let message = "MY_PASSWORD_UPDATED";
    if (!(payload || {}).oldPassword && !!(payload || {}).userId) {
      url = `account/set-password`;
      message = "PASSWORD_UPDATED";
    }
    const response = yield call(http.put, url, {
      ...payload,
    });

    yield all([
      put(actionCreators.ChangePasswordSuccess(response.data)),
      put(sendSuccessMessage(message)),
      put(actionCreators.ToggleChangePasswordModal(false)),
    ]);
  } catch (e) {
    yield put(actionCreators.ChangePasswordError(e.response));
  }
}

export function* onUpdateContactInfo({ payload }: Action<Object>): Generator<*, void, Object> {
  try {
    const response = yield call(http.put, "/api/v1/my-details/contact-info", payload);

    yield all([
      put(actionCreators.UpdateContactInfoSuccess(response.data)),
      put(sendSuccessMessage("CONTACT_INFO_UPDATED")),
      put(actionCreators.ToggleContactInfoModal(false)),
    ]);
  } catch (e) {
    yield put(actionCreators.UpdateContactInfoError(e.response));
  }
}

export default function* MyDetailsSaga(): Generator<*, void, void> {
  yield all([
    takeEvery(ChangePassword, onChangePassword),
    takeEvery(GetContactInfoSchema, onGetContactInfoSchema),

    takeEvery(UpdateContactInfo, onUpdateContactInfo),
  ]);
}
